export const defaultTableSelection = {
  hoveredColumns: [],
  hoveredRows: [],
  isInDanger: false
};